module.exports = __webpack_public_path__ + "img/credit_refused.86d48ff0.png";